export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_e003ca4c-a8bf-436e-a131-0998c39ef750/artifacts/6y2oq4hw_logo%20bull%20delivery%20testa%20grande%20500x500.png";

export const BRAND_NAME = "Io Amo La Mia Città";
export const COMPANY_NAME = "Bull Marketing S.r.l.s.";
export const P_IVA = "02178200388";

export const CITIES = ["Cento (FE)", "San Giovanni in Persiceto", "San Pietro in Casale"];

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
